
import { useState } from 'react';
import './App.css';

function App() {
  const [value,setvalue]=useState("0")
  const res=()=>{
    
    //  let x=eval(value)
    let x=value.slice(0,2)
    if(x=="01"||x=="02"||x=="03"||x=="04"||x=="05"||x=="06"||x=="07"||x=="08"||x=="09"||x=="00"){
      x=value.slice(1,)
    }else{
      x=value
    }
    setvalue(String(eval(x)))//2+5-6
  }
  const popstr=()=>{
    
    setvalue(value.slice(0,value.length-1))
  }
  console.log(value)
  return (
    <div className="App">
      <div class="box">
    <div class="insidebox">
      <div class="inputbox">{value}</div>
      <div class="buttons">
      <div class="button" onClick={()=>setvalue(value+1)}>1</div>
      <div class="button" onClick={()=>setvalue(value+2)}>2</div>
      <div class="button" onClick={()=>setvalue(value+3)}>3</div>
      <div class="button" onClick={()=>setvalue(value+"+")}>+</div>
      <div class="button" onClick={()=>setvalue(value+4)}>4</div>
      <div class="button" onClick={()=>setvalue(value+5)}>5</div>
      <div class="button" onClick={()=>setvalue(value+6)}>6</div>
      <div class="button" onClick={()=>setvalue(value+"-")}>-</div>
      <div class="button" onClick={()=>setvalue(value+7)}>7</div>
      <div class="button" onClick={()=>setvalue(value+8)}>8</div>
      <div class="button" onClick={()=>setvalue(value+9)}>9</div>
      <div class="button" onClick={()=>setvalue(value+"*")}>*</div>
      <div class="button" onClick={popstr}>del</div>
      <div class="button" onClick={()=>setvalue(value+0)}>0</div>
      <div class="button" onClick={()=>setvalue("0")}>c</div>
      <div class="button" onClick={()=>setvalue(value+"%")}>%</div>
      <div class="button" onClick={()=>setvalue(value+".")}>..</div>
      <div class="button" onClick={res}>=</div>
      </div>
      


    </div>
  </div>
    </div>
  );
}

export default App;
